import bannerCheddarCsFallback from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720'
import bannerCheddarCsAvif from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720&format=avif&as=srcset'
import bannerCheddarCsWebp from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720&format=webp&as=srcset'
import bannerCheddarDeFallback from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720'
import bannerCheddarDeAvif from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720&format=avif&as=srcset'
import bannerCheddarDeWebp from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720&format=webp&as=srcset'
import bannerCheddarHuFallback from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720'
import bannerCheddarHuAvif from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720&format=avif&as=srcset'
import bannerCheddarHuWebp from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720&format=webp&as=srcset'
import bannerCheddarPlFallback from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720'
import bannerCheddarPlAvif from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720&format=avif&as=srcset'
import bannerCheddarPlWebp from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720&format=webp&as=srcset'
import bannerCheddarRoFallback from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720'
import bannerCheddarRoAvif from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720&format=avif&as=srcset'
import bannerCheddarRoWebp from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720&format=webp&as=srcset'
import bannerCheddarSkFallback from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720'
import bannerCheddarSkAvif from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720&format=avif&as=srcset'
import bannerCheddarSkWebp from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720&format=webp&as=srcset'


import bannerCrunchyCsFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720'
import bannerCrunchyCsAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720&format=avif&as=srcset'
import bannerCrunchyCsWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720&format=webp&as=srcset'
import bannerCrunchyDeFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720'
import bannerCrunchyDeAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720&format=avif&as=srcset'
import bannerCrunchyDeWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720&format=webp&as=srcset'
import bannerCrunchyHuFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720'
import bannerCrunchyHuAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720&format=avif&as=srcset'
import bannerCrunchyHuWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720&format=webp&as=srcset'
import bannerCrunchyPlFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720'
import bannerCrunchyPlAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720&format=avif&as=srcset'
import bannerCrunchyPlWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720&format=webp&as=srcset'
import bannerCrunchyRoFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720'
import bannerCrunchyRoAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720&format=avif&as=srcset'
import bannerCrunchyRoWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720&format=webp&as=srcset'
import bannerCrunchySkFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720'
import bannerCrunchySkAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720&format=avif&as=srcset'
import bannerCrunchySkWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720&format=webp&as=srcset'

import bannerDeliveryCsFallback from '@/assets/images/temp-banners/banner-delivery-cs.jpg?w=720'
import bannerDeliveryCsAvif from '@/assets/images/temp-banners/banner-delivery-cs.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryCsWebp from '@/assets/images/temp-banners/banner-delivery-cs.jpg?w=720&format=webp&as=srcset'
import bannerDeliveryDeFallback from '@/assets/images/temp-banners/banner-delivery-de.jpg?w=720'
import bannerDeliveryDeAvif from '@/assets/images/temp-banners/banner-delivery-de.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryDeWebp from '@/assets/images/temp-banners/banner-delivery-de.jpg?w=720&format=webp&as=srcset'
import bannerDeliveryHuFallback from '@/assets/images/temp-banners/banner-delivery-hu.jpg?w=720'
import bannerDeliveryHuAvif from '@/assets/images/temp-banners/banner-delivery-hu.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryHuWebp from '@/assets/images/temp-banners/banner-delivery-hu.jpg?w=720&format=webp&as=srcset'
import bannerDeliveryPlFallback from '@/assets/images/temp-banners/banner-delivery-pl.jpg?w=720'
import bannerDeliveryPlAvif from '@/assets/images/temp-banners/banner-delivery-pl.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryPlWebp from '@/assets/images/temp-banners/banner-delivery-pl.jpg?w=720&format=webp&as=srcset'
import bannerDeliveryRoFallback from '@/assets/images/temp-banners/banner-delivery-ro.jpg?w=720'
import bannerDeliveryRoAvif from '@/assets/images/temp-banners/banner-delivery-ro.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryRoWebp from '@/assets/images/temp-banners/banner-delivery-ro.jpg?w=720&format=webp&as=srcset'
import bannerDeliverySkFallback from '@/assets/images/temp-banners/banner-delivery-sk.jpg?w=720'
import bannerDeliverySkAvif from '@/assets/images/temp-banners/banner-delivery-sk.jpg?w=720&format=avif&as=srcset'
import bannerDeliverySkWebp from '@/assets/images/temp-banners/banner-delivery-sk.jpg?w=720&format=webp&as=srcset'
import bannerDeliveryFrFallback from '@/assets/images/temp-banners/banner-delivery-fr.jpg?w=720'
import bannerDeliveryFrAvif from '@/assets/images/temp-banners/banner-delivery-fr.jpg?w=720&format=avif&as=srcset'
import bannerDeliveryFrWebp from '@/assets/images/temp-banners/banner-delivery-fr.jpg?w=720&format=webp&as=srcset'

export const tempBannersImages = [
  {
    name: 'banner_cheddar_cs.jpg',
    avif: bannerCheddarCsAvif,
    webp: bannerCheddarCsWebp,
    fallback: bannerCheddarCsFallback,
  },
  {
    name: 'banner_cheddar_de.jpg',
    avif: bannerCheddarDeAvif,
    webp: bannerCheddarDeWebp,
    fallback: bannerCheddarDeFallback,
  },
  {
    name: 'banner_cheddar_hu.jpg',
    avif: bannerCheddarHuAvif,
    webp: bannerCheddarHuWebp,
    fallback: bannerCheddarHuFallback,
  },
  {
    name: 'banner_cheddar_pl.jpg',
    avif: bannerCheddarPlAvif,
    webp: bannerCheddarPlWebp,
    fallback: bannerCheddarPlFallback,
  },
  {
    name: 'banner_cheddar_ro.jpg',
    avif: bannerCheddarRoAvif,
    webp: bannerCheddarRoWebp,
    fallback: bannerCheddarRoFallback,
  },
  {
    name: 'banner_cheddar_sk.jpg',
    avif: bannerCheddarSkAvif,
    webp: bannerCheddarSkWebp,
    fallback: bannerCheddarSkFallback,
  },
  {
    name: 'banner_crunchy_cs.jpg',
    avif: bannerCrunchyCsAvif,
    webp: bannerCrunchyCsWebp,
    fallback: bannerCrunchyCsFallback,
  },

  {
    name: 'banner_crunchy_de.jpg',
    avif: bannerCrunchyDeAvif,
    webp: bannerCrunchyDeWebp,
    fallback: bannerCrunchyDeFallback,
  },
  {
    name: 'banner_crunchy_hu.jpg',
    avif: bannerCrunchyHuAvif,
    webp: bannerCrunchyHuWebp,
    fallback: bannerCrunchyHuFallback,
  },
  {
    name: 'banner_crunchy_pl.jpg',
    avif: bannerCrunchyPlAvif,
    webp: bannerCrunchyPlWebp,
    fallback: bannerCrunchyPlFallback,
  },
  {
    name: 'banner_crunchy_ro.jpg',
    avif: bannerCrunchyRoAvif,
    webp: bannerCrunchyRoWebp,
    fallback: bannerCrunchyRoFallback,
  },
  {
    name: 'banner_crunchy_sk.jpg',
    avif: bannerCrunchySkAvif,
    webp: bannerCrunchySkWebp,
    fallback: bannerCrunchySkFallback,
  },
  {
    name: 'banner-delivery-cs.jpg',
    avif: bannerDeliveryCsAvif,
    webp: bannerDeliveryCsWebp,
    fallback: bannerDeliveryCsFallback,
  },
  {
    name: 'banner-delivery-de.jpg',
    avif: bannerDeliveryDeAvif,
    webp: bannerDeliveryDeWebp,
    fallback: bannerDeliveryDeFallback,
  },
  {
    name: 'banner-delivery-hu.jpg',
    avif: bannerDeliveryHuAvif,
    webp: bannerDeliveryHuWebp,
    fallback: bannerDeliveryHuFallback,
  },
  {
    name: 'banner-delivery-pl.jpg',
    avif: bannerDeliveryPlAvif,
    webp: bannerDeliveryPlWebp,
    fallback: bannerDeliveryPlFallback,
  },
  {
    name: 'banner-delivery-ro.jpg',
    avif: bannerDeliveryRoAvif,
    webp: bannerDeliveryRoWebp,
    fallback: bannerDeliveryRoFallback,
  },
  {
    name: 'banner-delivery-sk.jpg',
    avif: bannerDeliverySkAvif,
    webp: bannerDeliverySkWebp,
    fallback: bannerDeliverySkFallback,
  },
  {
    name: 'banner-delivery-fr.jpg',
    avif: bannerDeliveryFrAvif,
    webp: bannerDeliveryFrWebp,
    fallback: bannerDeliveryFrFallback,
  },
]
